// @ts-check

import React from 'react';
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import SolutionTile from './SolutionTile'

const useStyles = makeStyles((theme) => ({
  solutionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    minHeight: '300px',
    // height: '20%',
    maxHeight: '350px',
    // flexGrow: 1,
    // width: '70%',
    overflowY: 'auto',
    overflowX: 'auto',
    margin: '5px',
  }
}));

function SolutionsContainer(props) {
  const modelState = useSelector(state => state.model);
  const selectedName = useSelector(state => state.model?.renderedSolution?.solution_name)
  const styles = useStyles();

  const solutionTiles = modelState.solutions.map((s, i) => {
    return <SolutionTile solution={s} key={i} index={i} selectedName={selectedName} />
  })

  return (
    <div className={styles.solutionsContainer}>
      {solutionTiles}
    </div>
  )
}

export default SolutionsContainer